import { Component, Input, forwardRef, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { EditComponent }        from '../table/cell-components/actions/edit.component';
import { InvoiceModel }         from '../invoices/models/invoice';
import { QuotesService }        from './quotes.service';
import { SessionService }       from '../sessions/session.service';
import { Table }                from '../table/types/table';
import { TableQueryParameters } from '../table/types/table-query-parameters';

@Component({
  selector   : 'wor-accepted-quotes',
  template: require('./quotes.accepted-quotes.component.html')
})
export class QuotesAcceptedQuotesComponent{
  @Input() quotes : Array<InvoiceModel>;

  tableSettings : Table = {
    columns: [
      {
        field : 'display_name',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.CUSTOMER')
        }
      },
      {
        field : 'plate_number',
        header: {
          text: this.sessionService.company().company_variable_fields.plate_number_name
             || this.sessionService.countrySettings().rego_label
        }
      },
      {
        field : 'description',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'total',
        header: {
          text: this.translateService.instant('GENERAL_SPACE.FIELD.TOTAL')
        },
        pipe: 'globalCurrency',
      },
      {
        component: {
          bindings: {
            outputs: {
              onEditClick: ( quote : InvoiceModel ) => this.viewQuote(quote)
            }
          },
          enabled: true,
          factory: EditComponent,
        },
        sortable: false,
      }
    ],
    empty: {
      text: this.translateService.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ACCEPTED_QUOTES')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10 ],
      queryCount: () => this.quotesService.getAcceptedQuotesCount()
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      enabled: false
    },
  };

  constructor (
    @Inject(forwardRef(() => QuotesService)) private quotesService   : QuotesService,
    private router          : UIRouter,
    @Inject(forwardRef(() => SessionService))
    private sessionService  : SessionService,
    private translateService: TranslateService
  ) {}

  getQuotes ( params : TableQueryParameters ) : Promise<Array<InvoiceModel>> {
    return this.quotesService.getAcceptedQuotes(params)
      .then(( quotes : Array<InvoiceModel> ) => {
        this.quotes = quotes;

        return quotes;
      });
  }

  viewQuote ( quote : InvoiceModel ) : void {
    this.router.stateService.go('app.invoice', {
      customer_id: quote.customer_id,
      vehicle_id : quote.vehicle_id,
      id         : quote.id
    });
  }
}
